export default __webpack_public_path__ + "static/Milan-Laser-Hair-Removal-Opens-300th-Location-1b02872cefd79b0c28fd277edb37f0a3.pdf";